$(document).ready(function() {
    var utils = {
        generateID: function (base) {
          return base + Math.floor(Math.random() * 999);
        },
        focusIsInside: function (element) {
          return element.is(":focus") || element.has(document.activeElement).length;
        }
    };
      
    $icon = `<svg width="1em" height="1em" viewBox="0 0 24 24" aria-hidden="true">
                                  <path fill="currentColor" d="M5.293 9.707l6 6c0.391 0.391 1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
                              </svg>`;
    $nav = $("#hiah-site-nav");
    $navButton = $('#nav-toggle');
    $navCloseBtn = $("#nav-closeBtn");
    $navContent = $("#nav-content");
    $main = $("main");
    $footer = $("footer");
    $header = $("#main-header");
    $siblings = $("header .btn-lang, header .header__home-link");
    $dropdowns = $("li[data-has-children] > ul");
    
      
      let navIsShown = true;
    
      function showNavigationContent(e) {
        $navButton.attr("aria-expanded", "true");
        navIsShown = true;
        removeNavInert();
        makePageInert();
        closeNavWhenFocusLeaves($navContent);
        $navCloseBtn.siblings('ul').find('a').first().focus();
      }
    
      $navButton.on("click", showNavigationContent);
    
      
      $navCloseBtn.on(
        "click",
        function () {
          hideNav();
          $navButton.focus();
        }
      );
      
      function hideNav() {
        $navButton.attr("aria-expanded", "false");
        $dropdowns.each(function () {
          $(this).attr("hidden", "");
          $btn = $(this).siblings("button");
          $btn.attr("aria-expanded", "false");
        });
        navIsShown = false;
        makeNavInert();
        removePageInert();
      }
      
      function makePageInert() {
        if ($main) {
          $main.prop("inert", true);
        }
        if ($footer) {
          $footer.prop("inert", true);
        }

        $siblings.each(function(){
            $(this).prop("inert", true);
        })
      }
      
      function removePageInert() {
        if ($main) {
          $main.prop("inert", false);
        }
        if ($footer) {
          $footer.prop("inert", false);
        }
      
        $siblings.each(function() {
            $(this).prop("inert", false)
        })
      }
      
      function makeNavInert() {
        $navContent.prop("inert", true);
      }
      
      function removeNavInert() {
        $navContent.prop("inert", false);
      }
      function closeNavWhenFocusLeaves(element) {
        var firstClass = "js-first-focus";
        var lastClass = "js-last-focus";
      
        var tabFocusElements =
          'button:not([hidden]):not([disabled]), [href]:not([hidden]), input:not([hidden]):not([type="hidden"]):not([disabled]), select:not([hidden]):not([disabled]), textarea:not([hidden]):not([disabled]), [tabindex="0"]:not([hidden]):not([disabled]), summary:not([hidden]), [contenteditable]:not([hidden]), audio[controls]:not([hidden]), video[controls]:not([hidden])';
        $focusable = element.find(tabFocusElements);
        // the first focusable element is the toggle button, but with the nav open, we don't want that one to be focused
        $navCloseBtn.addClass(firstClass);
        $lastElement = $($focusable[$focusable.length - 1]);
        $lastElement.addClass(lastClass);
      
        element.on("keydown", function (e) {
          var keyCode = e.keyCode || e.which;
          var escKey = 27;
          var tabKey = 9;
      
          if (navIsShown) {
          switch (keyCode) {
            case escKey:
              hideNav();
              $navButton.focus();
              break;
      
            default:
              break;
          }
      
          if (document.activeElement.classList.contains(lastClass)) {
            if (keyCode === tabKey && !e.shiftKey) {
              e.preventDefault();
              hideNav();
            }
          }
      
          if (document.activeElement.classList.contains(firstClass)) {
            if (keyCode === tabKey && e.shiftKey) {
              e.preventDefault();
              hideNav();
            }
          }
          }
        });
      }
      
      $top_level_items = $("li[data-has-children]");
      $dropdowns = $("li[data-has-children] > ul");
      navID = utils.generateID("nav-");
      
      $top_level_items.each(function (index) {
        $dropdown = $(this).find("ul");
        $dropdown.attr("id", navID + "__ul-" + index);
        $dropdown.attr("hidden", "");
      
        $item_dw = $(this).find("button");
        $item_dw.attr("aria-expanded", "false");
        $item_dw.attr("aria-controls", navID + "__ul-" + index);
        
      });

      $dropdown_toggles = $("li[data-has-children] button");

      $dropdown_toggles.on("click", e => {
        let $toggle = $(e.currentTarget);
        let id = $toggle.attr("aria-controls");
        $dropdown = $(`#${id}`);
        toggleDropdown($toggle, $dropdown);
      })
    
      $dropdowns.on(
        "keydown",
        function (e) {
        let $toggle = $(e.currentTarget);
        let id = $toggle.attr("aria-controls");
        $dropdown = $(`#${id}`);
          e.stopImmediatePropagation(); // so that only the list itself closes, not its parent list (in the case of 3+ levels deep nested links)
          if (e.keyCode === 27 && utils.focusIsInside($dropdown)) {
            toggleDropdown($toggle, $dropdown);
            $toggle.focus();
          }
        }
      );
      
      function toggleDropdown(dw, dropdown) {
        if (dw.attr("aria-expanded") === "true") {
            dw.attr("aria-expanded", "false");
            dropdown.attr("hidden", "");
        } else { 
            dw.attr("aria-expanded", "true");
            dropdown.removeAttr("hidden");
        }
    }
      
        $navButton.removeAttr("hidden");
        $navCloseBtn.removeAttr("hidden");
        $navContent.attr("role", "group");
        $navContent.attr("aria-labelledby", "nav-toggle");
})



